export default {
  Submitted : 0,
  Refused : 1,
  Approved : 2,
  Promoted : 3
};